<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <div class="breadscrumbs">
      <a class="breadscrumbs-item active">Where To Buy</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Where To Buy</h2>
      <v-spacer></v-spacer>
      <button
        class="btn btn-primary"
        @click="$router.push({ name: 'WhereToBuyCreate' })"
      >
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增通路</span>
      </button>
    </div>
    <!-- Table -->
    <WhereToBuyTable></WhereToBuyTable>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import WhereToBuyTable from '@/views/H_WhereToBuy/c/WhereToBuyTable.vue';

export default {
  components: {
    WhereToBuyTable,
  },
  created() {
    this.clear();
    this.getBuyChannels();
  },
  methods: {
    ...mapActions('buyChannel', {
      getBuyChannels: 'find',
      clear: 'clear',
    }),
  },
};
</script>

<style></style>
